import React from "react";
import { RotatingLines } from "react-loader-spinner";
interface LoaderProps {
  width?: string;
  strokeColor?: string;
  strokeWidth?: string;
}
const Loader: React.FC<LoaderProps> = ({
  width = "100",
  strokeColor = "#24B1B3",
  strokeWidth = "4",
}) => {
  return (
    <div className="flex justify-center my-8">
      <RotatingLines
        width={width}
        visible={true}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
        animationDuration="0.75"
        ariaLabel="rotating-lines-loading"
      />
    </div>
  );
};

export default React.memo(Loader);
